import { useEffect, useState } from 'react';
import clsx from 'clsx';

import { useHeaderQuery } from '@api/HeaderApr/header.queries';

import { useMediaQuery } from '@hooks/useMediaQuery';

import Logo from '@components/Logo/Logo';

import Burger from './Burger/Burger';
import NavMenu from './NavMenu/NavMenu';
import LangSwitch from './LangSwitch/LangSwitch';
import Actions from './Actions/Actions';
import MobMenu from './MobMenu/MobMenu';

import css from './Header.module.scss';

const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const isMobile = useMediaQuery(992);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const { data, isLoading } = useHeaderQuery();

  if (isLoading) return null;

  const { navigation: navigationData, buttons: buttonsData } = data;

  return (
    <header
      className={clsx(
        css.header,
        isMobileMenuOpen && css.isOpen,
        isScrolled && css['is-scrolled']
      )}
    >
      <div className={css.header__main}>
        <div className="container">
          <div className={css.header__body}>
            <div className={css.header__logo}>
              <Logo />
            </div>

            {!isMobile && (
              <NavMenu isMobile={isMobile} navigationData={navigationData} />
            )}

            <div className={css.header__actions}>
              {!isMobile && <LangSwitch isMobile={isMobile} />}
              {!isMobile && (
                <Actions isMobile={isMobile} buttonsData={buttonsData} />
              )}
            </div>

            {isMobile && (
              <Burger
                isMobileMenuOpen={isMobileMenuOpen}
                setMobileMenuOpen={setMobileMenuOpen}
              />
            )}
          </div>
        </div>
      </div>

      {isMobile && (
        <MobMenu
          isMobile={isMobile}
          isMobileMenuOpen={isMobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
          navigationData={navigationData}
          buttonsData={buttonsData}
        />
      )}
    </header>
  );
};

export default Header;
